import { Card, Heading, Link, Paragraph } from "@digdir/designsystemet-react";
import { Link as InternalLink } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { cn } from "@/utils";

export const FjernAvtaleLink = ({ className }: { className?: string }) => {
  const { t } = useTranslation();

  return (
    <Card className={cn(className, "space-y-5")}>
      <Heading>{t("pages.fjern-avtaler.link.tittel")}</Heading>
      <Paragraph>{t("pages.fjern-avtaler.link.beskrivelse")}</Paragraph>
      <Link asChild>
        <InternalLink to={"/fjern-avtale"}>
          {t("pages.fjern-avtaler.link.link")}
        </InternalLink>
      </Link>
    </Card>
  );
};
